//import { validateEmail } from "../../utils/Validation";
import firebase from "firebase/app";

export function eliminarImagen(url) {
  return firebase
    .storage()
    .refFromURL(url)
    .delete();
}
